import React,{Component} from 'react';
import videojs from 'video.js'
import "video.js/dist/video-js.min.css";
// Forest
import './index.css';

export default class VideoPlayer extends Component {
    componentDidMount() {
        // instantiate Video.js
        let props = this.props;
        this.player = videojs(this.videoNode, this.props, function onPlayerReady() {
            props.hasOwnProperty("onPlayerReady") && props.onPlayerReady(this,this.videoNode)
        });
    }

    // destroy player on unmount
    componentWillUnmount() {
        if (this.player) {
            this.player.dispose()
        }
    }

    // wrap the player in a div with a `data-vjs-player` attribute
    // so videojs won't create additional wrapper in the DOM
    // see https://github.com/videojs/video.js/pull/3856
    render() {
        return (
            <div>
                <div data-vjs-player>
                    <video ref={ node => this.videoNode = node } className="video-js vjs-theme-forest"></video>
                </div>
            </div>

        )
    }

}